import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import "./Logout.scss";
import { SplitPageLayout } from "shared/components";

export const Logout = () => {
  const { logout } = useAuth0();

  useEffect(() => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }, [logout]);

  return (
    <SplitPageLayout
      title='Logging out'
      subtitle='You are being signed out of TracPro.'
    />
  );
};
